import './service-worker-injector'
import Shepherd from 'shepherd.js'
import { createPhiVisibilityController } from './phi-visibility'
import { registerPhiSafeTour } from './phi-safe-tour'
import { registerCpmRetirementTour } from './cpm-retirement-tour'
import { initProductTours } from './product-tours'
import { registerPatientChartTour } from './patient-chart-tour'
import { registerPatientChartV4Tour } from './patient-chart-v4-tour'
import { registerFastTooltips } from './fast-tooltips'
import { registerIvrWithdrawalTour } from './ivr-withdrawal-tour'
import { registerCaseloadTour } from './caseload-tour'
import { registerTwoFactorSetupTour } from './two-factor-setup-tour'
import { registerNurseCellCallTour } from './nurse-cell-call-tour'
import { registerBugReportTour } from './bug-report-tour'
import { registerNurseOnboardingTour } from './nurse-onboarding-tour'
import '../../Modules/NursePerformance/resources/js'
import './bootstrap';
import collapse from '@alpinejs/collapse'

import { registerHandler, sendRequest } from './broadcast-channel-job-manager'
import 'flatpickr/dist/flatpickr.css';
import flatpickr from "flatpickr";
import Choices from "choices.js";
import './audio-player'
import { startUiActivityTracking } from './ui-activity'

import Tooltip from "@ryangjchandler/alpine-tooltip";

window.Livewire.on('page::refresh', () => window.location.reload())

document.addEventListener('alpine:init', () => window.Alpine.plugin(Tooltip))
Alpine.plugin(collapse)

window.flatpickr = flatpickr;
window.Choices = Choices;
window.createPhiVisibilityController = createPhiVisibilityController
registerPhiSafeTour(window, document, Shepherd)
registerCpmRetirementTour(window, document, Shepherd)
registerIvrWithdrawalTour(window, document, Shepherd)
registerCaseloadTour(window, document, Shepherd)
registerTwoFactorSetupTour(window, document, Shepherd)
registerPatientChartTour(window, document)
registerPatientChartV4Tour()
registerFastTooltips(window, document)
registerNurseCellCallTour()
registerBugReportTour(window, document, Shepherd)
registerNurseOnboardingTour(window, document)
startUiActivityTracking(window, document)
initProductTours(window, document, Shepherd)

if (window) {
    window.registerHandler = registerHandler
    window.sendRequest = sendRequest
}

function confirmAndRedirect(msg, url) {
    if (confirm(msg)) {
        window.location.href = url
    }
}

window.confirmAndRedirect = confirmAndRedirect

window.highlightElement = function (element, duration = 3000) {
    const overlay = document.createElement('div')
    overlay.classList.add('focus-overlay')
    document.body.appendChild(overlay)

    const originalZIndex = element.style.zIndex
    element.classList.add('highlight-focus')

    element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
    })

    setTimeout(() => {
        element.classList.remove('highlight-focus')

        if (originalZIndex) {
            element.style.zIndex = originalZIndex
        }
        overlay.remove()
    }, duration)
}
